// @flow

import getUrl from 'hfty-utils/url'
import composeFetch from 'fc-fetch'
import { getToken } from 'fc-auth'

const heftyFetch = composeFetch({
  getUrl,
  getTokenSaga: getToken,
})

export const __get = heftyFetch.__get
export const __post = heftyFetch.__post
export const __put = heftyFetch.__put
export const __delete = heftyFetch.__delete
export default heftyFetch
